function EpharmLogo() {
  return (
    <div id="logo-container">
      <img id="logo" src="/epharm-ni-logo.png" alt="ePharmNI logo" />
    </div>
  );
}

export default EpharmLogo;
